import $ from 'jquery';
import Typed from 'typed.js';

( function() {
	const $el = $( '.c-typed-text' );

	if ( ! $el.length ) {
		return;
	}

	const $stage = $( '.c-typed-text__stage', $el );
	const $strings = $( '.c-typed-text__strings', $el );

	const handleResize = function() {
		$strings.show();

		const minHeight = Math.max(
			0,
			...$strings.children().map( ( index, el ) => $( el ).height() ).toArray()
		);

		$strings.hide();

		$el.css( 'min-height', minHeight + 'px' );
	};

	$( window ).on( 'resize orientationchange', handleResize );
	$( document ).on( 'sj.fontLoad.loaded sj.fontLoad.failed', handleResize );

	handleResize();

	new Typed(
		$stage[ 0 ],
		{
			loop: true,
			stringsElement: $strings[ 0 ],
			typeSpeed: 100,
			backDelay: 3000,
			autoInsertCss: false,
			startDelay: 1500,
		}
	);
}() );
